import * as React from 'react';
import { colors } from '../../../index';

const IconCalendar = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 17 17",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.506 1.992h-.498v-.498C15.008.67 14.338 0 13.514 0S12.02.67 12.02 1.494v.498h-1.993v-.498a1.495 1.495 0 00-2.987 0v.498H4.98v-.498C4.98.67 4.31 0 3.486 0S1.992.67 1.992 1.494v.498h-.498C.67 1.992 0 2.662 0 3.486v12.02C0 16.33.67 17 1.494 17h14.012C16.33 17 17 16.33 17 15.506V3.486c0-.824-.67-1.494-1.494-1.494zm-2.49-.498a.499.499 0 01.996 0v1.992a.499.499 0 01-.996 0V1.494zm-4.98 0a.499.499 0 01.995 0v1.992a.499.499 0 01-.996 0V1.494zm-5.048 0a.499.499 0 01.996 0v1.992a.499.499 0 01-.996 0V1.494zm13.016 14.012a.499.499 0 01-.498.498H1.494a.499.499 0 01-.498-.498V7.039h15.008v8.467zm0-9.463H.996V3.486a.5.5 0 01.498-.498h.498v.498c0 .824.67 1.494 1.494 1.494S4.98 4.31 4.98 3.486v-.498h2.06v.498c0 .824.67 1.494 1.493 1.494.824 0 1.494-.67 1.494-1.494v-.498h1.993v.498c0 .824.67 1.494 1.494 1.494s1.494-.67 1.494-1.494v-.498h.498a.5.5 0 01.498.498v2.557z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.51 8.035H2.49a.498.498 0 00-.498.498v5.977c0 .275.223.498.498.498h12.02a.498.498 0 00.498-.498V8.533a.498.498 0 00-.498-.498zm-9.53 5.977H2.988V12.02H4.98v1.992zm0-2.989H2.988V9.031H4.98v1.992zm3.055 2.989H5.977V12.02h2.058v1.992zm0-2.989H5.977V9.031h2.058v1.992zm2.988 2.989H9.031V12.02h1.992v1.992zm0-2.989H9.031V9.031h1.992v1.992zm2.989 2.989H12.02V12.02h1.992v1.992zm0-2.989H12.02V9.031h1.992v1.992z"
  }));
};

export default IconCalendar;